/*
 *  Copyright (c) yasc Informatik GmbH
 *  ALL RIGHTS RESERVED
 *  This software is protected by the inclusion of the above copyright
 *  notice. This software may not be provided or otherwise made available
 *  to, or used by, any other person. No title to or ownership of the
 *  software is  hereby  transferred.
 *  The information contained in this document is considered the
 *  CONFIDENTIAL and PROPRIETARY information of yasc Informatik GmbH and may
 *  not be disclosed or discussed with anyone who is not employed by
 *  yasc Informatik GmbH, unless the individual/company
 *  (i) has an express need to know such information, and
 *  (ii) disclosure of information is subject to the terms of a duly
 *  executed Confidentiality and Non-Disclosure Agreement between
 *  yasc Informatik GmbH and the individual/company.
 *
 */

import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'as',
    pure: true,
    standalone: false
})
export class AsPipePipe implements PipeTransform {
  transform<T>(value: any, _type: (new (...args: any[]) => T )| T): T {
    return value as T;
  }
}
